import React from 'react';
import { Icon, Spin } from 'antd';

import './index.less';


export const jobFailedIcon = <Icon type="close-circle" className="ant-icon-failed"/>;

export const jobSuccessIcon = <Icon type="check-circle" className="ant-icon-success"/>

export const jobRunManualIcon = <Icon type="exclamation-circle" className="ant-icon-run-manual"/>;

export const jobRunAutoSpin = <Spin size="small" spinning={true} type="loading"/>;

export const jobPendingIcon = <Icon type="exclamation-circle" className="ant-icon-pending"/>


// WEBPACK FOOTER //
// ./src/components/Alerts/index.jsx